<template>
    <body>
        <main id="main">
            <section>
                <div class="titulo">
                    <div class="margem container">
                        <h2>Gerenciamento de Responsáveis</h2>
                    </div>
                </div>
                <div class="grid-2 margem container">
                    <div class="bloco2 margem" style="font-size: medium;">
                        <div>
                            <ul>
                                <template v-for="(grupo, index) in grupos" :key="index">
                                    <li style="list-style: none;">
                                        <span @click="toggleExpandir(grupo)" style="cursor: pointer;">
                                            <i class="fa-regular"
                                                :class="{ 'fa-square-caret-down': grupo.expandido, 'fa-square-caret-right': !grupo.expandido }"></i>
                                            {{ grupo.descricaoDRE }} </span>
                                        <ul v-if="grupo.expandido && grupo.subgrupo" style="list-style: none;">
                                            <li v-for="(subgrupo, subindex) in grupo.subgrupo" :key="subindex">
                                                <span @click="toggleExpandir(subgrupo)" style="cursor: pointer;">
                                                    <i class="fa-regular"
                                                        :class="{ 'fa-square-caret-down': subgrupo.expandido, 'fa-square-caret-right': !subgrupo.expandido }"></i>
                                                    {{ subgrupo.descricaoDRE }} </span>
                                                <ul v-if="subgrupo.expandido && subgrupo.categoriaDRE"
                                                    style="cursor: pointer;">
                                                    <li v-for="(categoria, catIndex) in subgrupo.categoriaDRE"
                                                        :key="catIndex" @click="selectedCategory = categoria">
                                                        {{ categoria.descricao }}
                                                        <i v-if="categoria.sensivel"
                                                            class="fa-solid fa-shield-halved"
                                                            title="Categoria sensível"
                                                            style="margin-left: 6px; opacity: .7; font-size: .85em;"></i>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </div>
                    <div class="bloco2 margem bloco-responsaveis-sticky">
                        <div class="alinha-centro" style="font-size: medium;">
                            <span>Responsáveis:</span>&nbsp; <span><b>{{ selectedCategory?.descricao || '-'
                                    }}</b></span>
                        </div>
                        <div v-if="selectedCategory" class="categoria-sensivel-wrap">
                            <label class="categoria-sensivel" :class="{ marcada: !!selectedCategory.sensivel }">
                                <input type="checkbox" :checked="!!selectedCategory.sensivel"
                                    :disabled="salvandoSensivel"
                                    @change="toggleCategoriaSensivel($event.target.checked)" />
                                <span>Categoria sensível</span>
                                <span class="categoria-sensivel-estado">
                                    {{ selectedCategory.sensivel ? 'Sim' : 'Não' }}
                                </span>
                            </label>
                        </div>
                        <br /><br />
                        <div v-if="selectedCategory" class="tags m-b">
                            <a style="cursor: pointer;" v-for="(tipo, index) in tiposResponsavel" :key="index"
                                :class="tipoSelecionado == tipo ? 'ativo' : ''" @click="mudarTipoResponsavel(tipo)"> {{
                                    tipo }} </a>
                        </div>
                        <div v-if="selectedCategory">
                            <div style="position: relative;">
                                <input v-model="searchQuery" @focusin="filtrarUsers()" @input="filtrarUsers"
                                    @focusout="fecharLista()" placeholder="Pesquisar setor ou subsetor" type="text"
                                    class="form-control" />
                                <div v-if="filteredUsers" style="
                    z-index: 99999; max-height: 12rem; overflow: auto; background: var(--cor-bg);
                    border-bottom-left-radius: 12px; border-bottom-right-radius: 12px;
                    position: absolute; width: 100%; border: 1px solid var(--cor-separador);
                  ">
                                    <ul style="list-style: none; margin: 0; padding: .25rem 0;">
                                        <li v-for="opt in filteredUsers" :key="opt.id">
                                            <div @click="
                                                isUsuarioResponsavel(opt)
                                                    ? null
                                                    : associarUsuario(selectedCategory.grupos[tipoSelecionado] ?? [], { id: opt.id, nome: opt.nome })
                                                " :style="{
                                                    fontWeight: opt.nivel_hierarquico <= 2 ? 'bold' : 'normal',
                                                    color: isUsuarioResponsavel(opt) ? 'var(--cor-fonte-fraca)' : 'var(--cor-fonte-forte)',
                                                    cursor: isUsuarioResponsavel(opt) ? 'not-allowed' : 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '6px 10px',
                                                    borderRadius: '8px'
                                                }"> {{ opt.name }} </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="selectedCategory">
                            <br />
                            <div class="tags m-b" style="display: flex; gap: .5rem; flex-wrap: wrap;">
                                <span v-for="p in usuariosDoTipo" :key="p.vinculo_id ?? p.id"
                                    style="padding: .25rem .5rem; border: 1px solid var(--cor-separador); border-radius: 12px; display: inline-flex; align-items: center; gap: .35rem;">
                                    {{ p.nome }} <i class="fa-solid fa-circle-xmark"
                                        style="color: var(--cor-erro); cursor: pointer"
                                        @click.stop="desassociarUsuario(p)" title="Remover"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </body>
</template>
<script>
import estruturaService from '@/services/estrutura-service';
import pessoaService from '@/services/pessoa-service';
// import { api } from "roboflex-thalamus-request-handler"; 

export default {
    data() {
        return {
            filteredUsers: null,
            searchQuery: null,
            selectedCategory: null,
            modalArea: false,
            filtroNome: '',
            grupos: [],
            usuariosAdicionados: [],
            tiposResponsavel: ['Solicitante', 'Autorizador', 'Executor'],
            tipoSelecionado: 'Solicitante',
            setorOptions: [],
            salvandoSensivel: false,
        };
    },

    mounted() {
        this.obterEstrutura();
        this.obterTodosSetores();
    },

    computed: {
        usuariosDoTipo() {
            return this.selectedCategory?.grupos?.[this.tipoSelecionado] ?? [];
        },
    },

    methods: {
        async obterTodosSetores() {
            try {
                const resp = await pessoaService.obterTodosSetores();
                const arvore = Array.isArray(resp?.data) ? resp.data : [];
                this.setorOptions = this.achatarSetores(arvore);
            } catch (e) {
                console.error('Erro ao obter setores:', e);
            }
        },

        achatarSetores(lista, caminhoPai = '') {
            if (!Array.isArray(lista)) return [];
            return lista.flatMap((s) => {
                const display = caminhoPai ? `${caminhoPai} › ${s.nome}` : s.nome;
                const atual = {
                    id: s.id,
                    nome: s.nome,
                    display,
                    nivel_hierarquico: s.nivel_hierarquico ?? 0,
                    name: display,
                };
                const filhos = s.subsetor?.length ? this.achatarSetores(s.subsetor, display) : [];
                return [atual, ...filhos];
            });
        },

        mudarTipoResponsavel(tipo) {
            this.tipoSelecionado = tipo;
            this.filteredUsers = null;
            this.searchQuery = null;
        },

        fecharLista() {
            setTimeout(() => {
                this.filteredUsers = null;
                this.searchQuery = null;
            }, 200);
        },

        filtrarUsers() {
            const base = this.setorOptions || [];
            let fonteBase = base.map((s) => ({
                id: s.id,
                nome: s.nome ?? '',
                name: s.display ?? s.nome ?? '',
                nivel_hierarquico: s.nivel_hierarquico ?? 0,
            }));

            if (this.tipoSelecionado === 'Executor') {
                // const setoresPermitidos = ['suprimentos', 'infra e segurança', 'rh'];
                const idsVistos = new Set();
                fonteBase = fonteBase.filter((item) => {
                    // const nomeOriginal = (item.nome || '').trim();
                    // const nomeSemPrefixo = nomeOriginal.replace(/^\d+\./, '').toLowerCase();
                    // if (!setoresPermitidos.includes(nomeSemPrefixo)) return false;
                    if (idsVistos.has(item.id)) return false;
                    idsVistos.add(item.id);
                    return true;
                }).map((item) => ({
                    ...item,
                    name: item.nome.replace(/^\d+\./, '')
                }));
            }

            if (this.tipoSelecionado === 'Autorizador') {
                fonteBase = fonteBase.map((item) => ({
                    ...item,
                    name: item.nome.replace(/^\d+\./, '')
                }));
            }

            if (!this.searchQuery) {
                this.filteredUsers = fonteBase;
                return;
            }

            const q = this.searchQuery.toLowerCase();
            this.filteredUsers = fonteBase.filter(
                (item) =>
                    (item.name && item.name.toLowerCase().includes(q)) ||
                    (item.nome && item.nome.toLowerCase().includes(q))
            );
        },

        obterEstrutura(ano) {
            estruturaService
                .obterEstrutura(ano)
                .then((response) => {
                    const TIPOS = ['Solicitante', 'Autorizador', 'Executor'];
                    this.grupos = (response?.data ?? []).map((grupo) => {
                        (grupo.subgrupo ?? []).forEach((subgrupo) => {
                            subgrupo.expandido = false;
                            (subgrupo.categoriaDRE ?? []).forEach((categoria) => {
                                categoria.descricaoCompleta = `${subgrupo.descricaoDRE}: ${categoria.descricao}`;
                                categoria.sensivel = !!categoria.sensivel;
                                categoria.grupos = categoria.grupos ?? {};
                                TIPOS.forEach((t) => {
                                    if (!Array.isArray(categoria.grupos[t])) {
                                        categoria.grupos[t] = [];
                                    }
                                });
                            });
                        });
                        return grupo;
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        toggleExpandir(item) {
            this.expandirRecursivamente(item, !item.expandido);
        },

        expandirRecursivamente(item, expandido) {
            item.expandido = expandido;
            if (item.subgrupo) {
                item.subgrupo.forEach((subgrupo) => {
                    this.expandirRecursivamente(subgrupo, expandido);
                });
            }
        },

        isUsuarioResponsavel(entry) {
            return this.usuariosDoTipo.some((r) => r.id === entry.id);
        },

        async toggleCategoriaSensivel(valor) {
            if (!this.selectedCategory || this.salvandoSensivel) return;

            const valorAnterior = !!this.selectedCategory.sensivel;
            const novoValor = typeof valor === 'boolean' ? valor : !valorAnterior;
            this.selectedCategory.sensivel = novoValor;
            this.salvandoSensivel = true;

            try {
                await estruturaService.atualizarSensivelCategoria(this.selectedCategory.id, novoValor);
            } catch (e) {
                this.selectedCategory.sensivel = valorAnterior;
                console.error('Erro ao atualizar categoria sensível:', e);
            } finally {
                this.salvandoSensivel = false;
            }
        },

        async associarUsuario(_, entry) {
            if (!this.selectedCategory) return;

            const payload = {
                catDRE_id: this.selectedCategory.id,
                tipo: this.tipoSelecionado,
                setor_id: entry.id,
            };

            try {
                const resp = await pessoaService.atualizarResponsavel(payload);
                const vinculo_id = resp?.data?.vinculo_id ?? resp?.data?.id ?? null;

                const novo = [
                    ...this.usuariosDoTipo,
                    {
                        vinculo_id,
                        id: entry.id,
                        nome: entry.nome,
                        tipo: 'setor',
                    },
                ];

                this.selectedCategory.grupos = {
                    ...this.selectedCategory.grupos,
                    [this.tipoSelecionado]: novo,
                };
            } catch (err) {
                console.error('Erro ao associar setor:', err);
            }
        },

        async desassociarUsuario(entry) {
            if (!this.selectedCategory) return;
            const idVinc = entry?.vinculo_id;

            if (!idVinc) {
                console.error('Sem vinculo não é possível remover no backend.');
            } else {
                try {
                    await pessoaService.desvincular(idVinc);
                } catch (e) {
                    console.error('Erro ao desvincular:', e);
                }
            }

            const novo = this.usuariosDoTipo.filter((i) => i.id !== entry.id);
            this.selectedCategory.grupos = {
                ...this.selectedCategory.grupos,
                [this.tipoSelecionado]: novo,
            };
        },
    },
};
</script>
<style>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-container {
    max-height: 80%;
    width: 70%;
    padding: 3rem;
    overflow-y: auto;
    background-color: var(--cor-bg);
    border-radius: 20px;
    height: 20rem !important;
    overflow: hidden;
}

.bloco-responsaveis-sticky {
    position: sticky;
    top: 1rem;
    align-self: start;
}

.categoria-sensivel-wrap {
    display: flex;
    justify-content: center;
    margin-top: 0.75rem;
}

.categoria-sensivel {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0;
    padding: 0.4rem 0.75rem;
    border: 1px solid var(--cor-separador);
    border-radius: 12px;
    cursor: pointer;
    user-select: none;
    color: var(--cor-fonte-fraca);
    transition: all 120ms ease-in-out;
}

.categoria-sensivel:hover {
    border-color: var(--cor-erro);
}

.categoria-sensivel input[type="checkbox"] {
    margin: 0;
    cursor: pointer;
    accent-color: var(--cor-erro);
}

.categoria-sensivel .categoria-sensivel-estado {
    padding: 0.1rem 0.5rem;
    border-radius: 10px;
    background: var(--cor-cinza2);
    font-size: 0.85em;
    font-weight: 700;
}

.categoria-sensivel.marcada {
    border-color: var(--cor-erro);
    color: var(--cor-erro);
    font-weight: 700;
}

.categoria-sensivel.marcada .categoria-sensivel-estado {
    background: var(--cor-erro);
    color: var(--cor-bg);
}
</style>
